/**
 * Волна D (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute exact path='/store_old'>.
 *
 * ЭТАП 2 (решение Sergei, 29.08.2026): страница УСТАРЕЛА и выведена из
 * обращения — адрес отдаёт честный 404, SSR ему не нужен.
 *
 * 404 бросаем в beforeLoad: грузить нечего, а beforeLoad отрабатывает
 * раньше и не тянет за собой рендер. На сервере это HTTP 404 с контентом
 * /404, на клиентской навигации — та же страница «не найдено».
 *
 * Именно 404, а не 301: замены у страницы нет, склеивать адрес не с чем
 * (ср. /payment/* — там был редирект на /delivery).
 *
 * Компонент (StoresOldPage) намеренно НЕ удалён — это отдельное
 * решение; здесь снят только маршрут. Ссылок на этот адрес в приложении
 * нет (проверено поиском по исходникам 29.08.2026).
 */
import { createFileRoute, notFound } from '@tanstack/react-router';

export const Route = createFileRoute('/store_old')({
  beforeLoad: () => {
    throw notFound();
  }
});
